import { useGetPublicInstallmentProviderQuery } from '@massilia/queries'

/**
 * Financeur du 3x/4x avec frais, piloté par le flag backoffice. Partagé par la
 * mention de la carte, le bandeau d'explication et le filtre « Type de
 * paiement », qui doivent tous basculer en même temps.
 *
 * Le test porte sur `'SSP'`, pas sur `'FLOA'` : c'est la règle exacte du
 * serveur (`AppSettingService.getInstallmentProvider`), où seule une valeur
 * explicite `SSP` donne Oney et où tout le reste retombe sur FLOA depuis
 * l'incident SSP. Testé à l'envers, la seconde d'attente de la requête
 * affichait le logo Oney avant de basculer sur FLOA.
 */
export function useInstallmentPartner(): { logoSrc: string; name: 'FLOA' | 'Oney' } {
  const { data } = useGetPublicInstallmentProviderQuery()
  return data?.installmentProvider === 'SSP'
    ? { name: 'Oney', logoSrc: '/logos/logo-oney.jpg' }
    : { name: 'FLOA', logoSrc: '/logos/floa-logo.png' }
}
